// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login {
  height: 120vh;
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: center;
}
.login .card {
  width: 50%;
  display: flex;
  background-color: var(--body_background);
  border-radius: 10px;
  min-height: 200px;
  overflow: hidden;
}
.login .card .left {
  flex: 1 1;
  background: linear-gradient(rgba(11, 73, 96, 0.5), #CCD5FF), url("https://images.pexels.com/photos/9830108/pexels-photo-9830108.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1") center;
  background-size: cover;
  padding: 50px;
  display: flex;
  flex-direction: column;
  gap: 30px;
  color: white;
}
.login .card .left h1 {
  font-size: 70px;
  line-height: 0px;
}
.login .card .left span {
  font-size: 14px;
}
.login .card .left button {
  width: 50%;
  padding: 10px;
  border: none;
  background-color: #7CC6FE;
  color: var(--body_color);
  font-weight: bold;
  cursor: pointer;
}
.login .card .right {
  flex: 1 1;
  padding: 50px;
  display: flex;
  flex-direction: column;
  gap: 50px;
  justify-content: center;
}
.login .card .right h1 {
  color: var(--body_color);
}
.login .card .right form {
  display: flex;
  flex-direction: column;
  gap: 30px;
}
.login .card .right form input {
  border: none;
  border-bottom: 1px solid lightgray;
  padding: 20px 10px;
}
.login .card .right form button {
  width: 50%;
  padding: 10px;
  border: none;
  background-color: #7CC6FE;
  color: var(--body-color);
  font-weight: bold;
  cursor: pointer;
}

.error-popup {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 9999;
  width: 400px;
  background-color: white;
  border: 1px solid #ccc;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  padding: 20px;
  box-sizing: border-box;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.error-popup button {
  border: none;
  background-color: yellow;
  color: var(--body_background);
  cursor: pointer;
  display: inline-block;
  outline: 0;
  padding: 0 56px;
  height: 45px;
  line-height: 45px;
  border-radius: 7px;
  font-weight: 400;
  font-size: 16px;
  box-shadow: 0 4px 14px 0 rgba(0, 118, 255, 0.39);
  transition: background 0.2s ease, color 0.2s ease, box-shadow 0.2s ease;
  margin: 0 10px;
  z-index: 9999;
}
.error-popup button:hover {
  background-color: var(--body_color);
  color: var(--body_background);
  box-shadow: none;
}

.error-popup p {
  text-align: center;
  margin: 0 0 20px;
}`, "",{"version":3,"sources":["webpack://./src/pages/Login/Login.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,uBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AACJ;AACI;EAEI,UAAA;EACA,aAAA;EACA,wCAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;AAAR;AAGQ;EACI,SAAA;EACA,0LAAA;EACA,sBAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,YAAA;AADZ;AAGY;EACI,eAAA;EACA,gBAAA;AADhB;AAOY;EACI,eAAA;AALhB;AAOY;EACI,UAAA;EACA,aAAA;EACA,YAAA;EACA,yBAAA;EACA,wBAAA;EACA,iBAAA;EACA,eAAA;AALhB;AAWQ;EACI,SAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,uBAAA;AATZ;AAWY;EACI,wBAAA;AAThB;AAYY;EACI,aAAA;EACA,sBAAA;EACA,SAAA;AAVhB;AAagB;EACI,YAAA;EACA,kCAAA;EACA,kBAAA;AAXpB;AAegB;EACI,UAAA;EACA,aAAA;EACA,YAAA;EACA,yBAAA;EACA,wBAAA;EACA,iBAAA;EACA,eAAA;AAbpB;;AAqBA;EACI,eAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,aAAA;EACA,YAAA;EACA,uBAAA;EACA,sBAAA;EACA,wCAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EAEA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;AAnBJ;AAqBI;EACI,YAAA;EACA,wBAAA;EACA,6BAAA;EACA,eAAA;EACA,qBAAA;EACA,UAAA;EACA,eAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,gDAAA;EACA,uEAAA;EACA,cAAA;EACA,aAAA;AAnBR;AAsBI;EACI,mCAAA;EACA,6BAAA;EACA,gBAAA;AApBR;;AAwBA;EACI,kBAAA;EACA,gBAAA;AArBJ","sourcesContent":[".login{\n    height: 120vh;\n    background-color: white;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    .card{\n\n        width: 50%;\n        display: flex;\n        background-color: var(--body_background);\n        border-radius: 10px;\n        min-height: 200px;\n        overflow: hidden;\n\n\n        .left{\n            flex: 1;\n            background:linear-gradient(rgba(11, 73, 96, 0.5), #CCD5FF), url(\"https://images.pexels.com/photos/9830108/pexels-photo-9830108.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1\") center;\n            background-size: cover;\n            padding: 50px;\n            display: flex;\n            flex-direction: column;\n            gap: 30px;\n            color: white;\n\n            h1{\n                font-size: 70px;\n                line-height: 0px;\n\n            }\n            p{\n\n            }\n            span{\n                font-size: 14px;\n            }\n            button{\n                width: 50%;\n                padding: 10px;\n                border: none;\n                background-color: #7CC6FE;\n                color: var(--body_color);\n                font-weight: bold;\n                cursor: pointer;\n\n            }\n\n        }\n\n        .right{\n            flex: 1;\n            padding: 50px;\n            display: flex;\n            flex-direction: column;\n            gap: 50px;\n            justify-content: center;\n\n            h1{\n                color: var(--body_color);\n\n            }\n            form {\n                display: flex;\n                flex-direction: column;\n                gap: 30px;\n\n\n                input{\n                    border: none;\n                    border-bottom: 1px solid lightgray;\n                    padding: 20px 10px;\n\n                }\n\n                button{\n                    width: 50%;\n                    padding: 10px;\n                    border: none;\n                    background-color: #7CC6FE;\n                    color: var(--body-color);\n                    font-weight: bold;\n                    cursor: pointer;\n                }\n               \n            }\n        }\n    }\n}\n\n.error-popup {\n    position: fixed; \n    top: 50%; \n    left: 50%; \n    transform: translate(-50%, -50%);\n    z-index: 9999; \n    width: 400px; \n    background-color: white; \n    border: 1px solid #ccc; \n    box-shadow: 0 4px 8px rgba(0,0,0,0.1); \n    padding: 20px; \n    box-sizing: border-box;\n    border-radius: 10px; \n\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n\n    button {\n        border: none;\n        background-color: yellow;\n        color: var(--body_background);\n        cursor: pointer;\n        display: inline-block;\n        outline: 0;\n        padding: 0 56px;\n        height: 45px;\n        line-height: 45px;\n        border-radius: 7px;\n        font-weight: 400;\n        font-size: 16px;\n        box-shadow: 0 4px 14px 0 rgb(0 118 255 / 39%);\n        transition: background 0.2s ease, color 0.2s ease, box-shadow 0.2s ease;\n        margin: 0 10px;\n        z-index: 9999; \n    }\n\n    button:hover {\n        background-color: var(--body_color);\n        color: var(--body_background);\n        box-shadow: none;\n    }\n}\n\n.error-popup p {\n    text-align: center; \n    margin: 0 0 20px; \n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
